var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('types',{on:{"nodeClick":_vm.onNodeClick}}),_c('items',{ref:"itemTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }